import { createContext, createElement, useContext, type ReactNode } from 'react';

/**
 * Defaults to every control so a board rendered without a provider (such as a
 * component test) keeps them all. The server refuses writes the caller may not
 * make either way; this only decides whether the board offers them.
 */
const TrackerAccessContext = createContext({ canEdit: true, canManage: true });

export function TrackerAccessProvider({
  canEdit,
  canManage = true,
  children,
}: {
  canEdit: boolean;
  /** Columns themselves (adding, renaming, configuring, removing) stay with managers. */
  canManage?: boolean;
  children: ReactNode;
}) {
  return createElement(TrackerAccessContext.Provider, { value: { canEdit, canManage } }, children);
}

export function useCanEditTracker(): boolean {
  return useContext(TrackerAccessContext).canEdit;
}

export function useCanManageTrackerColumns(): boolean {
  const { canEdit, canManage } = useContext(TrackerAccessContext);
  return canEdit && canManage;
}
